(ns pfo.widget.toggler
  (:require [reagent.core :as reagent :refer [atom]]
            [pfo.form :refer [checked?]]))

(defn toggler [options]
  (let [checked (:checked options)
        flex-direction (get options :flex-direction "row-reverse")]
    (fn [options]
      [:label {:class "toggle-label"
               :style {:flex-direction flex-direction}}
       [:input {:type "checkbox"
                :class "toggle-input"
                :checked @checked
                :on-change (fn [ev]
                             (when-not (:disabled options) 
                               (if (:on-change options)
                                 ((:on-change options) ev))
                               (reset! checked (checked? ev))))}]
       [:div {:class (str "toggle-slider" (when (= (:size options) "small") " toggle-small"))}]
       [:span {:class (str "toggle-text" (when-not @checked " gray"))} (:label options)]])))

